import { useGetBrandsQuery, useGetModelsQuery } from '@api/api';
import { useSearchParams } from 'next/navigation';

export function useGetBrandNameById() {
  const { data } = useGetBrandsQuery();
  return (id: number): string => {
    let returnBrand = undefined as boolean | any;
    if (data?.data) {
      data.data.forEach((brand: any) => {
        if (brand.id == id) {
          returnBrand = brand.name;
        }
      });
    }
    return returnBrand;
  };
}

export function useGetModelNameById() {
  const searchParams = useSearchParams();
  const q = (param: string) => {
    return searchParams.get(param) ? String(searchParams.get(param)) : '';
  };
  const { data } = useGetModelsQuery(q('make_id'), {
    skip: !q('make_id'),
  });
  return (id: number): string => {
    let returnBrand = undefined as boolean | any;
    if (data?.data) {
      data.data.forEach((brand: any) => {
        if (brand.id == id) {
          returnBrand = brand.name;
        }
      });
    }
    return returnBrand;
  };
}
